import { STATSIG_DEFAULT_CLIENT_KEY } from '../constants';

declare global {
  interface Window {
    __STATSIG_CLIENT_KEY__?: string;
  }
}

/**
 * Returns app specific client key for Statsig SDK initialization. The key is expected to be injected on the window object by the server renderer. If the key is not found, it falls back to a default client key.
 */
const getClientKey = () => {
  return window.__STATSIG_CLIENT_KEY__ || STATSIG_DEFAULT_CLIENT_KEY;
};

export default getClientKey;
